import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

// Reusable components
import StatusBadge from "../common/StatusBadge";
import Loader from "../common/Loader";
import FileAttachment from "../common/FileAttachment";
import DocumentCard from "../common/DocumentCard";

import FilePreviewModal from "../common/FilePreviewModal";

// Utilities
import fileUtils from "../../utils/fileUtils";

// Redux actions
import {
  fetchGrievanceDetails,
  updateGrievanceStatus,
  fetchApplicantDetails,
  fetchGrievancesCatMaster,
} from "../../redux/actions/grievanceActions1";

// Import grievance details configuration
import grievanceConfig from "../common/GrievanceDetailsConfig";
import TimeLineItem2 from "../common/TimeLineItem2";

const GrievanceDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  // Get data from location state and redux store
  const { esm, id, centerName, cat, catId, entryDate } = location.state || {};
  const {
    currentGrievance,
    applicantDetails,
    loading,
    grievancecategoryMaster,
  } = useSelector((state) => state.grievances);

  const { user } = useSelector((state) => state.grievances);

  // Local state
  const [fileType, setFileType] = useState("");
  const [comments, setComments] = useState("");
  const [fileMetadata, setFileMetadata] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewAttachment, setPreviewAttachment] = useState(null);
  const [updateStatusId, setUpdateStatusId] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [masterData, setMasterData] = useState([]);
  console.log(masterData, "masterData");

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTransferCategory, setSelectedTransferCategory] = useState("");
  console.log(currentGrievance, applicantDetails);
  useEffect(() => {
    const filtered = grievancecategoryMaster?.filter(
      (item) => !catId?.includes(item.GRV_CAT_ID)
    );
    setMasterData(filtered || []);
  }, [catId, grievancecategoryMaster]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          await dispatch(fetchGrievancesCatMaster());
          await dispatch(fetchGrievanceDetails(id));
          await dispatch(fetchApplicantDetails(esm));
        }
      } catch (error) {
        console.error("Error fetching grievance data:", error);
      }
    };

    fetchData();
  }, [id, esm, dispatch]);

  // Get user role (default to 3 if not available)
  const userRole = user?.role || 3;

  // Get status ID from current grievance

  const currentStatusId =
    currentGrievance?.current_status_id?.toString() || "1";

  // Get allowed actions based on role and current status
  const allowedActions = grievanceConfig.getAllowedActions(
    userRole,
    currentStatusId
  );

  // Check if user can update status
  const canUpdate = grievanceConfig.canUpdateStatus(userRole, currentStatusId);

  // Check if user can upload documents
  const canUploadDocs = grievanceConfig.canUploadDocuments(userRole);

  // Get all attachments from grievance updates
  const getAllAttachments = () => {
    const attachments = [];
    if (currentGrievance?.updates) {
      for (const update of currentGrievance.updates) {
        if (update?.attachments && update.attachments.length > 0) {
          attachments.push(...update.attachments);
        }
      }
    }
    return attachments;
  };

  const allAttachments = getAllAttachments();

  // Handler functions
  const handleFileChange = (newFileMetadata) => {
    setFileMetadata(newFileMetadata);
  };

  const resetForm = () => {
    setUpdateStatusId("");
    setComments("");
    setFileMetadata([]);
    setSuccessMessage("");
    setErrorMessage("");
  };

  const closePreviewModal = () => {
    setIsPreviewModalOpen(false);
    setPreviewAttachment(null);
  };

  const handleTimelineAttachmentPreview = (state, attachment, name) => {
    setIsLoading(state);
    setPreviewAttachment(attachment);
    setFileType(name);
    if (!state) {
      setIsPreviewModalOpen(true);
    }
  };

  const handleUpdateStatus = async (statusId) => {
    if (!statusId) {
      setErrorMessage("Invalid status");
      return;
    }
    if (statusId !== "2") {
      if (!comments) {
        setErrorMessage("Please provide remarks");
        return;
      }
    }

    setUpdateStatusId(statusId);
    setIsSubmitting(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      let processedFiles = [];

      if (fileMetadata.length > 0 && canUploadDocs) {
        try {
          // Extract real file objects from file metadata
          const files = fileMetadata.filter((meta) => meta instanceof File);
console.log(files)
          // Process files for API
          if (files.length > 0) {
            processedFiles = await fileUtils.filesToAttachments(files);
          }
        } catch (fileError) {
          console.error("Error processing attachments:", fileError);
          setErrorMessage(`Error processing attachments: ${fileError.message}`);
          setIsSubmitting(false);
          return;
        }
      }

      const statusName = grievanceConfig.getStatusName(statusId);

      console.log(
        id,
        statusId,
        comments,
        processedFiles,
        catId,
        selectedTransferCategory
      );
      // Call API to update status
      const res = await dispatch(
        updateGrievanceStatus(
          id,
          statusId,
          comments,
          processedFiles,
          catId,
          selectedTransferCategory
        )
      );
      if (res.rCode == 0) {
        alert(res.rMessage || "Grievance Update Successfully");
      } else {
        alert(res.rMessage || "error");
      }

      if (userRole == 9) {
        navigate("/GrievanceList");
      }
      setSuccessMessage(`Grievance ${statusName.toLowerCase()} successfully`);
      resetForm();
      setIsChecked(false);
      closeModal();

      setSelectedTransferCategory("");
      await dispatch(fetchGrievanceDetails(id));
    } catch (error) {
      setErrorMessage(error.message || "Failed to update grievance status");
      console.error("Status update error:", error);
    } finally {
      setIsSubmitting(false);
      setUpdateStatusId("");
    }
  };

  // Get status message for displaying
  const statusMessage = grievanceConfig.getStatusMessage(
    currentStatusId,
    currentGrievance?.USER_RATING
  );

  const handleCheckboxClick = () => {
    setIsChecked(!isChecked);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleTransfer = async () => {
    if (selectedTransferCategory) {
      console.log(
        `Transferring grievance to category ID: ${selectedTransferCategory}`
      );
      await handleUpdateStatus("2");
    }
  };

  // Show loader while fetching data
  if (loading) {
    return <Loader message="Loading grievance details..." />;
  }

  return (
    <div className="grievance-details-container" style={{ zIndex: 1 }}>
      {/* File Preview Modal */}

      <FilePreviewModal
        isOpen={isPreviewModalOpen}
        onClose={closePreviewModal}
        attachment={previewAttachment}
        fileTypes={fileType}
      />

      {/* Floating Action Buttons */}
      <div className="floating-actions">
        <button
          className="fab-button"
          onClick={() => navigate("/GrievanceList")}
          title="Back to grievances"
        >
          <i className="bi bi-arrow-left"></i>
        </button>
      </div>

      {/* Grievance Header */}
      <div className="grievance-details-header">
        <div className="grievance-details-title">
          <div className="title-icon">
            <i className="bi bi-clipboard-check"></i>
          </div>
          <div>
            <h2>G{currentGrievance?.grv_id?.toString().padStart(10, "0")}</h2>
            <p className="grievance-subtitle">
              {currentGrievance?.grievance_details}
            </p>
          </div>
        </div>
        <StatusBadge
          status={grievanceConfig.getStatusName(currentStatusId)}
          size="large"
          color="#000"
        />
      </div>

      {/* Tab Navigation */}
      <div className="grievance-details-tabs">
        <button
          className={`tab-button ${activeTab === "overview" ? "active" : ""}`}
          onClick={() => setActiveTab("overview")}
        >
          <i className="bi bi-info-circle"></i> Overview
        </button>
        <button
          className={`tab-button ${activeTab === "timeline" ? "active" : ""}`}
          onClick={() => setActiveTab("timeline")}
        >
          <i className="bi bi-clock-history"></i> Status Trail
          {currentGrievance?.updates?.length > 0 && (
            <span className="tab-badge">
              {currentGrievance?.updates?.length}
            </span>
          )}
        </button>
        <button
          className={`tab-button ${activeTab === "documents" ? "active" : ""}`}
          onClick={() => setActiveTab("documents")}
        >
          <i className="bi bi-file-earmark"></i> Documents
          {allAttachments?.length > 0 && (
            <span className="tab-badge">{allAttachments?.length}</span>
          )}
        </button>
        {canUpdate && (
          <button
            className={`tab-button ${activeTab === "update" ? "active" : ""}`}
            onClick={() => setActiveTab("update")}
          >
            <i className="bi bi-pencil-square"></i> Update Progress
          </button>
        )}
      </div>

      {/* Tab Content */}
      <div className="grievance-details-content">
        {/* Overview Tab */}
        {activeTab === "overview" && (
          <div className="grievance-details-panel">
            {/* Applicant Information Card */}
            <div className="grievance-details-card applicant-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-person"></i> Applicant Information
                </h3>
                <div className="card-avatar">
                  <span>{applicantDetails?.USER_NAME?.charAt(0) || "U"}</span>
                </div>
              </div>
              <div className="card-body">
                <div className="applicant-name">
                  {applicantDetails?.USER_NAME}
                </div>

                <div className="info-grid">
                  <div className="info-item">
                    <div className="info-icon">
                      <i className="bi bi-calendar2"></i>
                    </div>
                    <div>
                      <div className="info-label">Submission Date</div>
                      <div className="info-value">{entryDate || "N/A"}</div>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon">
                      <i className="bi bi-building"></i>
                    </div>
                    <div>
                      <div className="info-label">ARESA Center</div>
                      <div className="info-value">{centerName || "N/A"}</div>
                    </div>
                  </div>

                  {applicantDetails?.SERVICE_NO && (
                    <div className="info-item">
                      <div className="info-icon">
                        <i className="bi bi-card-heading"></i>
                      </div>
                      <div>
                        <div className="info-label">Service No</div>
                        <div className="info-value">
                          {applicantDetails.SERVICE_NO}
                        </div>
                      </div>
                    </div>
                  )}

                  {applicantDetails?.RANK_NAME && (
                    <div className="info-item">
                      <div className="info-icon">
                        <i className="bi bi-star"></i>
                      </div>
                      <div>
                        <div className="info-label">Rank</div>
                        <div className="info-value">
                          {applicantDetails.RANK_NAME}
                        </div>
                      </div>
                    </div>
                  )}

                  {applicantDetails?.SOS_DATE && (
                    <div className="info-item">
                      <div className="info-icon">
                        <i className="bi bi-calendar-event"></i>
                      </div>
                      <div>
                        <div className="info-label">SOS Date</div>
                        <div className="info-value">
                          {applicantDetails.SOS_DATE}
                        </div>
                      </div>
                    </div>
                  )}

                  {currentGrievance?.ppoNo && (
                    <div className="info-item">
                      <div className="info-icon">
                        <i className="bi bi-file-earmark-text"></i>
                      </div>
                      <div>
                        <div className="info-label">PPO No</div>
                        <div className="info-value">
                          {currentGrievance.ppoNo}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="info-item">
                    <div className="info-icon">
                      <i className="bi bi-file-earmark-text"></i>
                    </div>
                    <div>
                      <div className="info-label">Section Name</div>
                      <div className="info-value">
                        {currentGrievance?.updates[0]?.SECTION_NAME || "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="info-item">
                    <div className="info-icon">
                      <i className="bi bi-file-earmark-text"></i>
                    </div>
                    <div>
                      <div className="info-label">Branch Name</div>
                      <div className="info-value">
                        {currentGrievance?.updates[0]?.BRANCH_NAME || "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Grievance Details Card */}
            <div className="grievance-details-card description-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-chat-left-text"></i> Grievance Details
                </h3>
              </div>
              <div className="card-body">
                <div className="category-badge">
                  <i className="bi bi-tag-fill"></i>
                  <span>{cat || "N/A"}</span>
                </div>

                <div className="description-box">
                  <div className="description-title">
                    <i className="bi bi-card-text"></i> Description
                  </div>
                  <div className="description-content">
                    {currentGrievance?.grievance_details}
                  </div>
                </div>

                <div className="status-action-section">
                  <div className="current-status">
                    <p className="status-label">Current Status</p>
                    <StatusBadge
                      status={grievanceConfig.getStatusName(currentStatusId)}
                    />
                  </div>

                  {canUpdate && (
                    <button
                      className="button primary"
                      onClick={() => setActiveTab("update")}
                    >
                      <i className="bi bi-pencil-square"></i>
                      Update Status
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Timeline Tab */}
        {activeTab === "timeline" && (
          <div className="grievance-details-panel full-width">
            <div className="grievance-details-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-clock-history"></i> Grievance Timeline
                </h3>
              </div>
              <div className="card-body">
                {currentGrievance?.updates?.length > 0 ? (
                  <div className="timeline-container">
                    {currentGrievance.updates.map((entry, index) => (
                      <TimeLineItem2
                        key={index}
                        action={entry.remarks}
                        status_name={entry.status_name}
                        date={entry.entry_datetime}
                        comments={entry.remarks}
                        attachments={entry.attachments}
                        user_name={entry.user_name}
                        onPreviewAttachment={handleTimelineAttachmentPreview}
                        isLast={index === currentGrievance.updates.length - 1}
                        isFirst={index === 0}
                        type="grievance"
                        isLoading={isLoading}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="empty-state">
                    <div className="empty-icon">
                      <i className="bi bi-clock-history"></i>
                    </div>
                    <p>No timeline events available for this grievance yet.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Documents Tab */}
        {activeTab === "documents" && (
          <div className="grievance-details-panel full-width">
            <div className="grievance-details-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-files"></i> Attached Documents
                </h3>
              </div>
              <div className="card-body">
                {allAttachments?.length > 0 ? (
                  <>
                    <ul className="document-categories">
                      <li className="category-active">All Documents</li>
                    </ul>

                    <div className="documents-grid">
                      {allAttachments.map((attachment, index) => (
                        <DocumentCard
                          filename={attachment.att_name}
                          attachmentId={attachment.grv_att_id} // grant_att_id, grv_att_id, or idcard_att_id
                          type="grievance" // or whatever type needed for the API
                          onPreview={handleTimelineAttachmentPreview}
                          isLoading={isLoading}
                        />
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="empty-state">
                    <div className="empty-icon">
                      <i className="bi bi-file-earmark-x"></i>
                    </div>
                    <p>No documents attached to this grievance</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Update Status Tab */}
        {activeTab === "update" && (
          <div className="branch-grievance-panel full-width">
            <div className="branch-grievance-card">
              <div className="branch-card-header">
                <h3>
                  <i className="bi bi-pencil-square"></i> Update Status
                </h3>
              </div>
              <div className="branch-card-body">
                {canUpdate ? (
                  <div className="branch-update-form">
                    {/* Display any success/error messages */}
                    {successMessage && (
                      <div className="branch-alert branch-alert-success">
                        <i className="bi bi-check-circle"></i> {successMessage}
                      </div>
                    )}
                    {errorMessage && (
                      <div className="branch-alert branch-alert-danger">
                        <i className="bi bi-exclamation-triangle"></i>{" "}
                        {errorMessage}
                      </div>
                    )}

                    {/* Remarks input */}
                    <div className="branch-form-group">
                      <label htmlFor="comments">
                        <i className="bi bi-chat-text"></i> Remarks
                      </label>
                      <textarea
                        id="comments"
                        className="branch-form-control"
                        rows="4"
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                        placeholder="Add your remarks or notes"
                        disabled={isSubmitting}
                      ></textarea>
                    </div>

                    {/* File attachment area - only shown for Branch users */}
                    {canUploadDocs && (
                      <div className="branch-form-group">
                        <label>
                          <i className="bi bi-paperclip"></i> Supporting
                          Documents
                        </label>
                        <FileAttachment
                          onChange={handleFileChange}
                          maxFiles={5}
                          maxSize={fileUtils.MAX_FILE_SIZE}
                          showPreview={true}
                          previewSize="small"
                          disabled={isSubmitting}
                          label="Attach Files (up to 5)"
                          helpText={`Supported formats: ${Object.keys(
                            fileUtils.ALLOWED_FILE_TYPES
                          )
                            .join(", ")
                            .toUpperCase()} (Max: ${fileUtils.formatFileSize(
                            fileUtils.MAX_FILE_SIZE
                          )} per file)`}
                        />

                        {/* Show attachment preview */}
                        {fileMetadata.length > 0 && (
                          <div className="branch-attachment-container mt-3">
                            <div className="branch-attachment-count">
                              <i className="bi bi-paperclip"></i>{" "}
                              {fileMetadata.length} file(s) attached
                            </div>
                            <div className="branch-attachment-list">
                              {fileMetadata.map((file, index) => (
                                <div
                                  className="branch-attachment-item"
                                  key={index}
                                >
                                  <div className="branch-attachment-icon">
                                    <i
                                      className={`bi ${
                                        fileUtils.getFileIconAndClass(file.name)
                                          .icon
                                      }`}
                                    ></i>
                                  </div>
                                  <div className="branch-attachment-name">
                                    {file.name}
                                  </div>
                                  <button
                                    className="branch-attachment-remove"
                                    onClick={() => {
                                      const newFiles = [...fileMetadata];
                                      newFiles.splice(index, 1);
                                      handleFileChange(newFiles);
                                    }}
                                    type="button"
                                    disabled={isSubmitting}
                                  >
                                    <i className="bi bi-x"></i>
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Action buttons */}
                    <div className="branch-form-actions">
                      <button
                        className="branch-button branch-button-secondary"
                        onClick={resetForm}
                        disabled={isSubmitting}
                        type="button"
                      >
                        <i className="bi bi-x-circle"></i> Cancel
                      </button>

                      {/* Render action buttons based on role and status */}
                      {allowedActions.map((action) => (
                        <button
                          key={action.id}
                          className={`branch-button ${action.buttonClass}`}
                          onClick={() => handleUpdateStatus(action.id)}
                          disabled={isSubmitting || !comments}
                          type="button"
                          title={action.description}
                        >
                          {isSubmitting && updateStatusId === action.id ? (
                            <>
                              <i
                                className={`bi ${action.icon} branch-icon-spin`}
                              ></i>{" "}
                              Processing...
                            </>
                          ) : (
                            <>
                              <i className={`bi ${action.icon}`}></i>{" "}
                              {action.label}
                            </>
                          )}
                        </button>
                      ))}
                      {userRole == 9 && (
                        <button
                          className="branch-button branch-button-outline-primary d-flex align-items-center"
                          onClick={handleCheckboxClick}
                          type="button"
                        >
                          <div className="form-check me-2 mb-0">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="transferCheckbox"
                              checked={isChecked}
                              onChange={() => {}}
                            />
                          </div>
                          <span>Transfer to</span>
                        </button>
                      )}
                      {isModalOpen && (
                        <div
                          className="modal show d-block"
                          tabIndex="-1"
                          style={{
                            backgroundColor: "rgba(0,0,0,0.5)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                            <div className="modal-content border-0 shadow">
                              <div className="modal-header sticky-top bg-white border-bottom">
                                <h5 className="modal-title">
                                  Transfer Options
                                </h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  onClick={closeModal}
                                ></button>
                              </div>

                              <div className="position-sticky top-0 px-3 py-2 bg-light border-bottom">
                                <div className="input-group">
                                  <span className="input-group-text bg-white border-end-0">
                                    <i className="bi bi-search"></i>
                                  </span>
                                  <input
                                    type="text"
                                    className="form-control border-start-0 ps-0"
                                    placeholder="Search categories..."
                                    value={searchQuery || ""}
                                    onChange={(e) =>
                                      setSearchQuery(e.target.value)
                                    }
                                  />
                                  {searchQuery && (
                                    <button
                                      className="btn btn-outline-secondary border-start-0"
                                      type="button"
                                      onClick={() => setSearchQuery("")}
                                    >
                                      <i className="bi bi-x"></i>
                                    </button>
                                  )}
                                </div>
                              </div>

                              <div
                                className="modal-body p-0"
                                style={{ maxHeight: "50vh", overflowY: "auto" }}
                              >
                                <div className="list-group list-group-flush">
                                  {masterData
                                    .filter(
                                      (category) =>
                                        !searchQuery ||
                                        category.GRV_CAT.toLowerCase().includes(
                                          searchQuery.toLowerCase()
                                        )
                                    )
                                    .map((category) => {
                                      return (
                                        <div
                                          key={category.GRV_CAT_ID}
                                          className="list-group-item"
                                        >
                                          <button
                                            type="button"
                                            className={`btn btn-link text-decoration-none p-0 m-0 d-flex justify-content-between align-items-center w-100 text-start ${
                                              selectedTransferCategory ===
                                              category.GRV_CAT_ID
                                                ? "active"
                                                : ""
                                            }`}
                                            onClick={() =>
                                              setSelectedTransferCategory(
                                                category.GRV_CAT_ID
                                              )
                                            }
                                          >
                                            <div className="d-flex align-items-center">
                                              <div className="category-icon me-3">
                                                <i className="bi bi-tag-fill"></i>
                                              </div>
                                              <div>
                                                <div className="fw-medium">
                                                  {category.GRV_CAT}
                                                </div>
                                                <small className="text-muted">
                                                  {category.SECTION_NAME}
                                                </small>
                                              </div>
                                            </div>
                                            {selectedTransferCategory ===
                                              category.GRV_CAT_ID && (
                                              <i className="bi bi-check-circle-fill text-success fs-5"></i>
                                            )}
                                          </button>
                                        </div>
                                      );
                                    })}
                                  {!masterData.some((category) =>
                                    category.GRV_CAT.toLowerCase().includes(
                                      searchQuery.toLowerCase()
                                    )
                                  ) && (
                                    <div className="py-4 text-center text-muted">
                                      <i className="bi bi-search d-block fs-4 mb-2"></i>
                                      <p className="mb-0">
                                        No categories match your search
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <>
                                <div className="modal-footer sticky-bottom bg-white border-top">
                                  <button
                                    type="button"
                                    className="branch-button branch-button-secondary"
                                    onClick={closeModal}
                                  >
                                    <i className="bi bi-x-circle me-1"></i>
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    className="branch-button branch-button-primary"
                                    onClick={handleTransfer}
                                    disabled={!selectedTransferCategory}
                                  >
                                    <i className="bi bi-arrow-right-circle me-1"></i>
                                    Transfer
                                  </button>
                                </div>
                              </>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    className={`branch-status-message branch-status-${statusMessage.type}`}
                  >
                    <div className="branch-status-icon">
                      <i
                        className={`bi ${
                          statusMessage.type === "success"
                            ? "bi-check-circle-fill"
                            : statusMessage.type === "error"
                            ? "bi-x-circle-fill"
                            : "bi-info-circle-fill"
                        }`}
                      ></i>
                    </div>
                    <div className="branch-status-content">
                      <h4>{statusMessage.title}</h4>
                      <p>{statusMessage.description}</p>
                      {currentStatusId ===
                        grievanceConfig.GRIEVANCE_STATUS.CLOSED &&
                        currentGrievance?.USER_RATING && (
                          <div className="user-rating-display mt-3">
                            <p className="mb-1 fw-bold">User Rating:</p>

                            <div className="d-flex align-items-center">
                              {/* Generate star rating based on actual rating value */}
                              {[...Array(5)].map((_, i) => (
                                <i
                                  key={i}
                                  className={`bi ${
                                    i < currentGrievance.USER_RATING
                                      ? "bi-star-fill"
                                      : "bi-star"
                                  }`}
                                  style={{
                                    color:
                                      i < currentGrievance.USER_RATING
                                        ? "#FFD700"
                                        : "#ccc",
                                    fontSize: "1.5rem",
                                    marginRight: "5px",
                                  }}
                                ></i>
                              ))}
                              <span className="ms-2 fs-5">
                                ({currentGrievance.USER_RATING}/5)
                              </span>
                            </div>

                            {/* Show user feedback if available */}
                            {currentGrievance.USER_FEEDBACK && (
                              <div className="user-feedback mt-2">
                                <p className="mb-1 fw-bold">User Feedback:</p>
                                <div className="feedback-content p-2 bg-light rounded border">
                                  "{currentGrievance.USER_FEEDBACK}"
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      {isLoading && <Loader></Loader>}
    </div>
  );
};

export default GrievanceDetails;
